export const DEFAULT_ICD_SEARCH_SIZE = 10;
